




































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, namespace } from 'vuex-class'
import { getEnvironments } from '@/environments'
import { StoreError } from '@/store/modules/account/types'
const env = getEnvironments()

const ACCOUNT_MODULE = 'account'

@Component({
  components: {
  }
})
export default class Login extends Vue {
  @Prop() private grupotipovariable!: string
  @Action('sendCredentials', { namespace: ACCOUNT_MODULE })
  private sendCredentials: any
  @Getter('token', { namespace: ACCOUNT_MODULE })
  private token!: string

  @Getter('errors', { namespace: ACCOUNT_MODULE })
  private errors!: StoreError

  private logo: string = env.url.logo

  private email: string = ''
  private password: string = '';

  async handleLogin ({ email, password }: any) {
    await this.sendCredentials({ email, password })
    if (this.errors.state === true) {
      this.$notify({
        group: 'alert-group',
        type: 'error',
        text: this.errors.message
      })
    }
    if (this.token && this.token !== '') {
      this.$router.push({ path: '/pronostico-hidrico' })
    }
  }
}
